<template>
    <div class="px-4 py-8 sm:px-10">
        <p>{{ translate('finished.body:content') }}</p>
        <br />
        <p class="whitespace-pre-wrap" v-html="translate('finished.body:signature')"></p>
        <div class="pt-5 text-right">
            <a :href="route('dashboard_display_localized')" class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">{{ translate('finished.body:dashboardButton') }}</a>
        </div>

    </div>
</template>

<script>

import translate from "../../lang";
import {usePage} from "@inertiajs/inertia-vue3";

export default {
    components: {
    },
    props: {
        nft: Object
    },
    setup() {
        return {
            translate: translate('upload-' + usePage().props.value.metaDataType.type)
        }
    }
};
</script>
